import { makeStyle } from '../../utils';
import { OYO_THEME } from '../../resources/colors';
import { bold, caption, rowCenter } from '../../resources/styles';
import view from '../../Enums';

const styles = [];


styles['container'] = makeStyle({ width: '100%', height: '100%', overflowY: 'auto' }, { display: 'flex', flexDirection: 'column', overflowY: 'hidden' });


styles['header'] = makeStyle({
    backgroundColor: OYO_THEME,
    width: '100%', minHeight: 88,
    display: 'flex',
    alignItems: 'flex-end',
    boxSizing: 'border-box',
    justifyContent: 'space-between',
}, {}, {}, { minHeight: 60 });


styles['oyo_logo'] = makeStyle({}, {padding: 16}, view.DESKTOP, { padding: 12 });


styles['back_link'] = makeStyle([caption, bold, rowCenter, { color: 'white', paddingLeft: 4, whiteSpace: 'nowrap' }]);

styles['back_link_arrow'] = makeStyle({ height: 18, width: 18 });


styles['header_text'] = makeStyle({
    fontWeight: 900, color: 'white', marginLeft: 24, padding: 16, textAlign: 'right',
}, { fontSize: 28 }, { fontSize: 20 }, { fontSize: 16, padding: 12 });

styles['header_text_small'] = makeStyle({ fontSize: 14 });


styles['content'] = makeStyle({}, { display: 'flex', flex: 1, overflow: 'hidden' });


styles['left'] = makeStyle({}, {
    width: '50%', height: '100%', padding: '24px', boxSizing: 'border-box', overflowY: 'auto'
}, {}, {
    padding: 12,
});


styles['right'] = makeStyle({}, { width: '50%', height: '100%', paddingTop: 24, boxSizing: 'border-box' }, { paddingTop: 16 });


export default styles;